import React, { Component } from 'react';
import styles from './ImportPage.module.scss';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../../context/CustomContext';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { FormInstance, Steps } from 'antd';
import { EntityWithStatus, Member } from '../../../../model/entities';
import UploadComponent from './UploadComponent/UploadComponent';
import SummaryComponent from './SummaryComponent/SummaryComponent';
import ResultComponent from './ResultComponent/ResultComponent';

class ImportPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {
            step: 0,
            members: [],
        };
    }

    /** METHODS **/

    showMembers = (members: Member[]) => {
        const step = 1;
        this.setState({ step, members });
    };

    showResults = (result: EntityWithStatus<Member>[]) => {
        const step = 2;
        this.setState({ step, result });
    };

    back = () => {
        const step = this.state.step - 1;
        this.setState({ step });
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        const { step, members, result } = this.state;

        return (
            <>
                <h1 className={styles.title}>
                    <FormattedMessage id="members.import.title" />
                </h1>
                <Steps current={step} className={styles.steps}>
                    <Steps.Step title={<FormattedMessage id="members.import.steps.1" />} />
                    <Steps.Step title={<FormattedMessage id="members.import.steps.2" />} />
                    <Steps.Step title={<FormattedMessage id="members.import.steps.3" />} />
                </Steps>
                <div hidden={step !== 0}>
                    <UploadComponent onLoadMembers={this.showMembers} />
                </div>
                {step === 1 && (
                    <SummaryComponent members={members} onSaveMembers={this.showResults} onBack={this.back} />
                )}
                {step === 2 && <ResultComponent result={result!} />}
            </>
        );
    };

    render() {
        return <LayoutComponent pageId="members">{this.renderContent()}</LayoutComponent>;
    }
}
export default injectIntl(ImportPage);

interface Props extends WrappedComponentProps {}

interface State {
    step: number;
    members: Member[];
    result?: EntityWithStatus<Member>[];
    loading?: boolean;
}
